import type { FaireProductEntity } from "../../entity_types/product";

export const p_7dsvu83hpc: FaireProductEntity = {
  token: "p_7dsvu83hpc",
  type: "product",
  name: "Exposed Seamed Athleisure Tank Top & Sweatpants Set",
  brandToken: "b_f4kavkbe9g",
  brandName: "HIDDENBRAND",
  imageUrl:
    "https://cdn.faire.com/fastly/7ab54bd760a8b0ce0785f48d63f802e740e800fa8c9bb9e36d632a3e13452751.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/14e838cbbc437dd112345088a02c258b1c28b75cf5018929d7af6f4f61bc3e3d.jpeg",
    "https://cdn.faire.com/fastly/0bbdca050aea8b4b518a7263a6a7d9c792cd7df70346dac2f2cab5c87f9c872e.jpeg",
    "https://cdn.faire.com/fastly/d50160d3407682cae5220aa9940c71305241e4f5179253a45ec4b413d9a52d93.jpeg",
    "https://cdn.faire.com/fastly/e9764ee92676ff73ae1693791a7c501145725f87506932a444a22d87ce5a3faf.jpeg",
    "https://cdn.faire.com/fastly/292f589a0643ac9f3b37fde8f092c398a03d912edf1fd253ca427f94edff2a5f.jpeg",
    "https://cdn.faire.com/fastly/24ffd55cfefbe8f0bc77b97505a402b29c1d24d52bb3d7d1fdcc7226c2f95fb7.jpeg",
    "https://cdn.faire.com/fastly/3a612f8245e41b1327893240c8699c81caa9b479f5f16eed6f12428a6369d5cf.jpeg",
    "https://cdn.faire.com/fastly/c931c77b55da32f2adf20dd5af213173ae58406cf6c8a193606e62932cef3617.jpeg",
  ],
  priceDollars: 18.03,
  description:
    "Import duties are paid by the HiddenBrand_HJW05048\nOur product size standards are different, please check the size information before placing an order. \n\nSize Chart(Inch)\t\t\t\t\t\n\t Chest\tLength  Pants Length\tHip\t    Waist\nM\t 31.50 \t 19.88 \t     40.16 \t    40.94 \t 26.77 \nL\t 33.86 \t 20.47 \t 40.55 \t    43.31 \t     29.13 \nXL\t 36.22 \t 21.06  40.94 \t    45.67 \t     31.50 \n2XL\t 38.58 \t 21.65 \t 41.34 \t    48.03 \t 33.86 \n\nWomen blazer, shackets, crochet cardigan, cable knit sweater, ruffle dress, eyelet blouse, puff sleeve top, floral dress, denim skirts, denim shorts, ripped jeans, Women jeans, maxi skirt, floral dress, jumpsuit, crop top, short sleeve, wholesale t shirts, beach cover ups, women t shirt, women shorts, women pants, bohemian, boho, fall top, fall t shirt, fall dress, maxi dress, fall tee, women fall top, fall blouse, western",
  tags: [],
  msrpDollars: 36.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:35.551Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
